module.exports = countryGroups;